<template>
  <div>
    <div :class="styles">
      <ValidationProvider
        :name="fieldName"
        :rules="validationRules"
        v-slot="{ errors }"
      >
        <b-field>
          <template #label
            >{{ label
            }}<span v-if="required" class="has-text-danger">*</span></template
          >

          <b-select
            expanded
            @click.native="
              () => {
                if (selectFun) {
                  selectFun();
                }
              }
            "
            :disabled="disabled"
            v-model="vModelVaribale"
          >
            <option
              v-for="option in selectOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.langTranslation }}
            </option>
          </b-select>
        </b-field>
        <span class="has-text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelectLabel",

  props: [
    "value",
    "selectOptions",
    "validationRules",
    "label",
    "disabled",
    "selectFun",
    "styles",
    "fieldName",
    "required",
  ],

  components: {},
  data() {
    return {
      errorFromProvider: "",
    };
  },
  methods: {
    sendError(error) {
      this.$emit(`getError`, error);
    },
  },
  computed: {
    vModelVaribale: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style></style>
